module.exports = __webpack_public_path__ + "static/transparency-9ce01a8dfc4d54b4dfcb59f7b7c582a0.png";